import { getPageName } from '@/constants/common';
import { SHIFTED_TEXT } from '@/constants/layout';
import { cn } from '@/lib/utils';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';

const PdfHeader: FC = () => {
  const location = useLocation();

  return (
    <div
      id="pdf-header"
      className="pdf-header w-full h-[50px] flex justify-between items-center mx-auto mt-6  mb-2"
    >
      <div className="block text-left text-neutral-950 text-sm">
        <div className={cn(SHIFTED_TEXT, 'text-base uppercase font-bold')}>
          {getPageName(location.pathname)}
        </div>
      </div>
      <div className="w-[36px] h-[50px]">
        <img
          className="w-full h-full"
          src={'/era-logo.png'}
          alt=""
        />
      </div>
    </div>
  );
};

export default PdfHeader;
